import React from 'react';
import { InviteAcceptErrorCodes } from './invite-accept-error-codes';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

export const getAcceptErrorDetails = (error, marketplaceName) => {
  switch (error?.Errors[0]?.Code) {
    case InviteAcceptErrorCodes.selfInviteError:
      return {
        title: <FormattedMessage {...messages.selfInviteErrorTitle} />,
        content: <FormattedMessage {...messages.selfInviteErrorMessage} values={{ marketplaceName }} />,
      };
    case InviteAcceptErrorCodes.inviteNotFound:
      return {
        title: <FormattedMessage {...messages.inviteNotFoundErrorTitle} />,
        content: <FormattedMessage {...messages.inviteNotFoundErrorMessage} values={{ marketplaceName }} />,
      };
    case InviteAcceptErrorCodes.inviteNotPending:
      return {
        title: <FormattedMessage {...messages.inviteNotPendingErrorTitle} />,
        content: <FormattedMessage {...messages.inviteNotPendingErrorMessage} values={{ marketplaceName }} />,
      };
    case InviteAcceptErrorCodes.registrationFailed:
      return {
        title: <FormattedMessage {...messages.failedConnectionTitle} />,
        content: <FormattedMessage {...messages.failedConnectionMessage} values={{ marketplaceName }} />,
      };
    default:
      return {
        title: <FormattedMessage {...messages.failedConnectionTitle} />,
        content: <FormattedMessage {...messages.failedConnectionMessage} values={{ marketplaceName }} />,
      };
  }
};
